export function initHeaderDropdownMenu() {
    const headerMain = document.querySelector('.header-flex');
    const body = document.body;
    if (!headerMain) return;

    const dropdownItems = Array.from(
        headerMain.querySelectorAll<HTMLLIElement>('.header-menu__item_dropdown')
    );
    const nonDropdownItems = Array.from(
        headerMain.querySelectorAll<HTMLLIElement>('.header-menu__item:not(.header-menu__item_dropdown)')
    );
    const headerButton = headerMain.querySelector<HTMLElement>('.header-button');

    if (!dropdownItems.length) return;

    let activeItem: HTMLLIElement | null = null;
    let isDesktop = window.innerWidth > 1279;

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // -----------------------------------------------------------
    // DESKTOP
    // -----------------------------------------------------------

    function desktopSetActive(item: HTMLLIElement) {
        if (activeItem && activeItem !== item) {
            activeItem.classList.remove('active');
        }

        item.classList.add('active');
        activeItem = item;

        body.classList.add('menu-show');
        body.style.paddingRight = scrollbarWidth + 'px';
    }

    function desktopClearActive() {
        if (activeItem) {
            activeItem.classList.remove('active');
            activeItem = null;
        }
        body.classList.remove('menu-show');
        body.style.paddingRight = '';
    }

    function initDesktopEvents() {
        dropdownItems.forEach(item => {
            item.addEventListener('mouseenter', () => {
                if (!isDesktop) return;
                desktopSetActive(item);
            });
        });

        nonDropdownItems.forEach(item => {
            item.addEventListener('mouseenter', () => {
                if (!isDesktop) return;
                desktopClearActive();
            });
        });

        headerButton?.addEventListener('mouseenter', () => {
            if (!isDesktop) return;
            desktopClearActive();
        });

        headerMain.addEventListener('mouseleave', () => {
            if (!isDesktop) return;
            desktopClearActive();
        });
    }

    // -----------------------------------------------------------
    // MOBILE
    // -----------------------------------------------------------

    function initMobileEvents() {
        if (window.innerWidth > 1279) return; // сразу выходим на desktop

        dropdownItems.forEach(item => {
            const btn = item.querySelector<HTMLElement>('.header-menu__item-drop');
            const drop = item.querySelector<HTMLElement>('.dop-menu');
            if (!btn || !drop) return;

            // Только для mobile
            drop.style.overflow = 'hidden';
            drop.style.transition = 'height 0.3s ease';
            drop.style.height = '0px';

            btn.addEventListener('click', (e) => {
                e.preventDefault();

                const isActive = item.classList.contains('active');

                if (isActive) {
                    item.classList.remove('active');
                    drop.style.height = '0px';
                    return;
                }

                // Закрываем все остальные
                dropdownItems.forEach(i => {
                    if (i !== item) {
                        i.classList.remove('active');
                        const otherDrop = i.querySelector<HTMLElement>('.dop-menu');
                        if (otherDrop) otherDrop.style.height = '0px';
                    }
                });

                item.classList.add('active');
                drop.style.height = drop.scrollHeight + 'px';
            });
        });
    }


    // -----------------------------------------------------------
    // INIT
    // -----------------------------------------------------------

    function applyMode() {
        const nowDesktop = window.innerWidth > 1279;

        if (nowDesktop !== isDesktop) {
            isDesktop = nowDesktop;

            if (isDesktop) {
                // desktop — НЕ трогаем высоту dop-menu
                desktopClearActive();
            } else {
                // mobile — сброс всех активных dropdown
                dropdownItems.forEach(item => {
                    item.classList.remove('active');
                    const drop = item.querySelector<HTMLElement>('.dop-menu');
                    if (drop) drop.style.height = '0px';
                });
            }
        }
    }

    initDesktopEvents();
    initMobileEvents();
    applyMode();

    window.addEventListener('resize', applyMode);
}
